/**
 * International-friendly check: digits only, length within ITU-T E.164 limits (max 15 digits).
 * Accepts local or full international numbers (e.g. 05..., +972..., +1..., spaces/dashes ignored).
 */
const MIN_DIGITS = 8;
const MAX_DIGITS = 15;

export function isValidContactPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  return digits.length >= MIN_DIGITS && digits.length <= MAX_DIGITS;
}
